import React, { useEffect, useState } from "react";
import { getPrivacyPolicy, getSeoByUrl } from "../api/api";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState("");
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.privacy_policy) {
        setPolicy(response.data.privacy_policy);
      } else {
        setPolicy("<p>Failed to load privacy policy.</p>");
      }
    };
    fetchPolicy();
  }, []);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("privacy-policy");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };
    fetchSeoData();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <Helmet>
        {/* ================= PRIMARY META ================= */}
        <title>
          {seoData.metaTitle || "Privacy Policy | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Read Nutrillion's privacy policy for data protection"}
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/privacy-policy"}
        />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "Privacy Policy | Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || "Read Nutrillion's privacy policy for data protection"} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/privacy-policy"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}
        <meta property="og:site_name" content="Nutrillion" />

        {/* ================= TWITTER CARD ================= */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "Privacy Policy | Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || "Read Nutrillion's privacy policy for data protection"} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

        {/* ================= SCHEMA MARKUP ================= */}
      {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default PrivacyPolicy;